angular.module('rjmNg.controllers').controller('tourWelcomeCtrl', [
  "$scope"
  "$modal"
  "dashboardService"
  "userEventService"
  "tourTypes"
  ($scope, $modal, dashboardService, userEventService, tourTypes) ->

    $scope.vrbTour = tourTypes.VRB_TOUR
    $scope.dashTour = tourTypes.DASH_TOUR

    $scope.skipTour = (modal, tourType) ->
      dashboardService.readyForCallToAction()
      userEventService.logTourSkipped()
      modal 'hide'

    $scope.next = (modal, tourType) ->
      dashboardService.beginTourSteps(tourType)  # start the tour
      modal 'hide'

  ]
)
